import { render, staticRenderFns } from "./RecentPublications.vue?vue&type=template&id=67a810ec&scoped=true&"
import script from "./RecentPublications.vue?vue&type=script&lang=js&"
export * from "./RecentPublications.vue?vue&type=script&lang=js&"
import style0 from "./RecentPublications.vue?vue&type=style&index=0&id=67a810ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a810ec",
  null
  
)

export default component.exports